module.exports = __webpack_public_path__ + "media/images/trust-icon-block-8622c1f536d7002ebeebb6ee374d6864.svg";